export default __webpack_public_path__ + "static/media/galletas-mantequilla.0cf96e28.jpg";